/* eslint-disable curly */
import React, { Component, useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  Dimensions,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Animated,
  Platform,
  ScrollView,
  Switch,
  KeyboardAvoidingView,
  ImageBackground,
} from "react-native";
import { TextInputMask } from "react-native-masked-text";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Icon from "react-native-vector-icons/FontAwesome";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import { getAluno, alterarSenha } from "../../services/aluno-service";
import { alert } from "../../utils/alerts";

const widthScreen = Dimensions.get("screen").width;
const widthInput = "90%";

const AlterarSenha = ({ navigation }) => {
  const [senhaNova, setSenhaNova] = useState("");
  const [senhaAntiga, setSenhaAntiga] = useState("");
  const [senhaNovaConfirma, setSenhaNovaConfirma] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);

  const handlerSenhaAntiga = async (e) => {
    setSenhaAntiga(e.trim());
  };

  const handlerSenhaNova = async (e) => {
    setSenhaNova(e.trim());
  };

  const handlerSenhaNovaConfirma = async (e) => {
    setSenhaNovaConfirma(e.trim());
  };

  useEffect(() => {
    if (senhaAntiga === "" || senhaNova === "" || senhaNovaConfirma === "") {
      setConfirmDisabled(true);
    } else {
      console.log(senhaNova !== senhaNovaConfirma);
      if (senhaNova !== senhaNovaConfirma) return setConfirmDisabled(true);
      setConfirmDisabled(false);
    }
  }, [senhaAntiga, senhaNova, senhaNovaConfirma]);

  const enviar = async () => {
    setLoading(true);

    try {
      const response = await alterarSenha(senhaAntiga, senhaNova);
      if (!response.ok) {
        let { erro } = await response.json();
        setLoading(false);
        return alert("Ops...", erro);
      }
      Keyboard.dismiss();

      navigation.pop(1);
      setLoading(false);
    } catch (erro) {
      setLoading(false);
      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o numero e tente novamente"
      );
    }
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.select({
          ios: "padding",
          android: "null",
        })}
        keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
      >
        <ImageBackground
          source={require("../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={[styles.containerForm]}>
            <ScrollView
              style={{ flex: 1, width: "100%" }}
              contentContainerStyle={{ alignItems: "center" }}
            >
              <Text style={styles.textHeader1}>Informe sua senha antiga</Text>
              <TextInput
                style={styles.input}
                placeholder="Sua senha antiga"
                placeholderTextColor="#ccc"
                secureTextEntry={true}
                autoFocus={true}
                onChangeText={handlerSenhaAntiga}
              />
              <View style={styles.hr}></View>
              <Text style={styles.textHeader1}>Informe sua nova senha</Text>
              <TextInput
                style={styles.input}
                placeholder="Sua nova senha"
                placeholderTextColor="#ccc"
                secureTextEntry={true}
                onChangeText={handlerSenhaNova}
              />
              <View style={styles.hr}></View>
              <Text style={styles.textHeader1}>Confirme sua nova senha</Text>
              <TextInput
                style={styles.input}
                placeholder="Confirmar senha"
                placeholderTextColor="#ccc"
                secureTextEntry={true}
                onChangeText={handlerSenhaNovaConfirma}
              />
            </ScrollView>
            <ButtonConfirm
              text={loading ? "Enviando..." : "Enviar"}
              disabled={confirmDisabled}
              onPress={enviar}
              msgDisabled={
                senhaAntiga === "" &&
                senhaNova === "" &&
                senhaNovaConfirma === ""
                  ? "Preencha todos os campos"
                  : senhaNovaConfirma !== senhaNova
                  ? "A nova senha e a confirmações precisam ser iguais"
                  : ""
              }
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

AlterarSenha.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          const navigateAction = StackActions.pop(1);
          navigation.dispatch(navigateAction);
        }}
      >
        <Icon
          style={styles.iconToggle}
          name="arrow-left"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default AlterarSenha;
